import {Navbar} from "./components/Navbar";
import {Outlet} from "react-router-dom";

export const App = () => {
  return <div>
      <Navbar/>
      <div style={{height:"100px"}}/>
      <Outlet/>
  </div>
}